import React, { useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import {
  PageContainer,
  MainContent,
  IntroSection,
  IntroGrid,
  IntroHeading,
  IntroTextContainer,
  IntroText,
  MDSection,
  MDContainer,
  MDLayout,
  MDHeader,
  MDTitle,
  MDHeading,
  MDMainContent,
  MDImageWrapper,
  MDImage,
  MDTextContent,
  MDParagraph,
  MDQuote,
  Container,
} from './About.styled';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <PageContainer>
      <Header />

      <MainContent>
        {/* Intro Section - Now acts as the page header */}
        <IntroSection>
          <Container>
            <IntroGrid>
              <IntroHeading
                initial="hidden"
                animate="visible"
                variants={fadeIn}
              >
                Excellence in Pipe <br /> Support Solutions.
              </IntroHeading>
              <IntroTextContainer
                initial="hidden"
                animate="visible"
                variants={staggerContainer}
              >
                <IntroText variants={fadeIn}>
                  Founded in 1970, Swan Pipe Support has grown into a trusted
                  name in pipe support and clamping solutions, serving customers
                  across India and overseas. With decades of industry
                  experience, we specialize in manufacturing ready-to-use,
                  reliable, and economical support systems for Plumbing,
                  Electrical, HVAC, Fire-fighting, and Mechanical applications.
                </IntroText>
                <IntroText variants={fadeIn}>
                  Our products are designed for strength, consistency, and ease
                  of installation, helping dealers, builders, and contractors
                  achieve dependable performance on every project. Backed by
                  organized manufacturing, quality-driven processes, and a
                  strong partner-first approach, Swan continues to support
                  projects that are built to last.
                </IntroText>
              </IntroTextContainer>
            </IntroGrid>
          </Container>
        </IntroSection>

        {/* MD Message Section */}
        <MDSection>
          <Container>
            <MDContainer>
              <MDLayout>
                <MDHeader>
                  <MDTitle
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                  >
                    Leadership Perspective
                  </MDTitle>
                  <MDHeading
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                  >
                    Managing Director’s Core Message
                  </MDHeading>
                </MDHeader>

                <MDMainContent>
                  <MDImageWrapper
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                  >
                    <MDImage src="/img/about/MD.jpeg" alt="Managing Director" />
                  </MDImageWrapper>

                  <MDTextContent
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={staggerContainer}
                  >
                    <MDParagraph variants={fadeIn}>
                      At Swan Pipe Support, our journey has always been driven
                      by one simple belief—
                      <strong>
                        strong buildings need stronger support systems.
                      </strong>
                    </MDParagraph>
                    <MDParagraph variants={fadeIn}>
                      From day one, our focus has been on creating ready-to-use,
                      reliable, and economical pipe support solutions that make
                      work easier on site and more dependable over the long
                      term. Strength, consistency, ease of use, and durability
                      are never compromised.
                    </MDParagraph>
                    <MDParagraph variants={fadeIn}>
                      For our dealer partners, Swan represents trust and
                      continuity. We believe in clear pricing, ready
                      availability, and long-term relationships built on mutual
                      growth. You are offering your customers an organized,
                      dependable support system that delivers value beyond
                      price.
                    </MDParagraph>
                    <MDParagraph variants={fadeIn}>
                      For builders and contractors, Swan is a performance
                      partner. Our high-thickness, tested, and standardized
                      support systems are designed to handle demanding site
                      conditions while enabling faster installation, cleaner
                      execution, and lasting reliability. Our goal is to reduce
                      uncertainties on site so teams can focus on building with
                      confidence.
                    </MDParagraph>
                    <MDParagraph variants={fadeIn}>
                      As Managing Director, my commitment is to ensure that Swan
                      continues to stand for quality without compromise,
                      technical responsibility, and dependable partnerships.
                      When the support system is right, everything built on it
                      stands stronger.
                    </MDParagraph>
                    <MDQuote variants={fadeIn}>
                      Together, let’s build projects that last.
                    </MDQuote>
                  </MDTextContent>
                </MDMainContent>
              </MDLayout>
            </MDContainer>
          </Container>
        </MDSection>
      </MainContent>

      <Footer />
    </PageContainer>
  );
};

export default About;
